import { Injectable } from '@angular/core';
import { ApiEndpointService } from '../../../core/services/api-endpoint.service';
import { HttpClientService } from '../../../core/services/http/http-client.service';
import { Observable } from 'rxjs';
import SafeUrlAssembler from 'safe-url-assembler';
import { IBanner } from './models/banner.interface';

@Injectable()
export class BannerService {
  constructor(private httpClientService: HttpClientService, private apiEndpointService: ApiEndpointService) {
  }

  public getDashboardBanners(stationId: string): Observable<IBanner[]> {
    const endpoint = SafeUrlAssembler().template(this.apiEndpointService.getEndpoint('getDashboardBanners'))
    // const endpoint = SafeUrlAssembler().template(`https://api-uat.parcelpro.com/v3.0/api/marketing/banners`)
      .query({
        stationID: stationId,
        device: 1,
      })
      .toString();

    return this.httpClientService.get<IBanner[]>(endpoint);
  }
}
